import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { mapState } from "vuex";
import swal from "sweetalert";

extend("email", email);
extend("required", {
  ...required,
  message: "This field is required",
});

export default {
  computed: {
    ...mapState({
      status: (state) => state.Authenticate.status,
    }),
  },
  data: () => ({
    form:{
      robot: false,
    },
    validation_message: "",
    valid: false,
    email: "",
    logo:require('../../assets/Frame.svg'),
    background_image:require('../../assets/login_home.png')
  }),
  methods: {
    async delete_account() {
      const self = this;

      const valid = await this.$refs.validator.validate();
      self.setValidationMessage("");
      if (valid) {

        swal({
          title: "Are you sure you want to delete your account?",
          text: "All data will be lost.",
          icon: "warning",
          buttons: ["No", "Yes"],
          dangerMode: true,
        }).then(async (willDelete) => {
          if (willDelete) {

            await self.$store
              .dispatch("Authenticate/delete_account", { email: self.email })
              .then((response) => {
                if(response.code == 'SUCCESS'){
                  this.email = '';
                  this.$refs.form.reset(); 
                  swal("Deleted Account", "Successful!!", "success", {
                    buttons: false,
                    timer: 3000
                  });
                }
              })
              .catch(() => {
                self.setValidationMessage("Invalid email");
              });

          } else {
            swal("Your account is safe", "The account was not deleted", "info", {
              buttons: false,
              timer: 2000,
            });
          }
        });
      }
      
    },
    setValidationMessage(message) {
      this.validation_message = message;
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
};
